import type { WeaponDef } from '../../sim/defs';
import { PbMode } from '../../sim/pools/BulletPool';
import { Stat } from '../../sim/stats';

/** A05 — RICOCHET. « Rounds qui SAUTENT d'un ennemi au suivant »
 *  (nœud `arme-ricochet`, ouvert par « boss vaincu sans être touché »).
 *
 *  10 volées/s × 2 projectiles × 10 dégâts = 200 DPS — le MÊME nombre que le
 *  VULCAN, au chiffre près.
 *
 *  ── Un vrai TYPE de balle : l'ARC du moteur ────────────────────────────────
 *  Ses balles sont marquées `PbMode.Arc` : elles survivent au contact et sautent
 *  vers l'ennemi le plus proche (à courte portée, 270 u), exactement comme l'Orage
 *  électrique secondaire. C'est l'exact opposé du Perforant : l'arc se moque de
 *  l'alignement et ne regarde que la DENSITÉ locale. Médiocre sur une cible
 *  isolée — un seul contact — excellent sur un paquet.
 *
 *  ── ⚠️ Le power creep, borné par les mêmes deux garde-fous que le Perforant ──
 *  Budget de contacts court (`PRIMARY_PIERCE_HITS` = 3) ET décroissance de dégâts
 *  par saut (`PRIMARY_PIERCE_FALLOFF` = 0,6) : trois ennemis groupés reçoivent
 *  1 + 0,6 + 0,36 = 1,96× le mono-cible, jamais 3×. Réservé au tir primaire ; les
 *  secondaires à arc (Orage) ne sont pas décrues. Le seuil est vérifié par
 *  `tests/balance/multicible.test.ts`.
 *
 *  ── La contrepartie : des rounds 30 % plus LENTS ──────────────────────────
 *  Il faut être PRÈS d'un groupe pour que l'arc accroche ; des projectiles plus
 *  lents (1 260 u/s contre 1 800) laissent aux cibles plus de temps pour se
 *  disperser avant l'impact, et raccourcissent la portée utile. On paie la forme
 *  sur la statistique qui peut la payer — `bulletSpeed` n'entre pas dans `dps()`,
 *  donc le nominal reste à 200. */
const ricochet: WeaponDef = {
  id: 'ricochet',
  name: 'Ricochet',
  modifiers: [
    // Change la NATURE du projectile — arc — sans toucher au DPS nominal.
    { stat: Stat.BulletMode, op: 'add', value: PbMode.Arc },
    // Contrepartie : 30 % plus lent, donc portée utile plus courte et cibles qui
    // ont le temps de s'écarter. Ne change pas le DPS.
    { stat: Stat.BulletSpeed, op: 'mul', value: -0.3 },
  ],
  text: '10 volées/s × 2 × 10 dégâts — 200 DPS, rounds qui RICOCHENT, plus lents',
};

export default ricochet;
